import React, { useState } from 'react'
import styled, { css, keyframes } from 'styled-components'
import { motion } from 'framer-motion'

import easings from './../../styles/easings'

import cloud01 from './../../../img/cloud-01.png'
import cloud02 from './../../../img/cloud-02.png'
import cloud03 from './../../../img/cloud-03.png'
import cloud04 from './../../../img/cloud-04.png'
import cloud05 from './../../../img/cloud-05.png'

import branchLeft from './../../../img/branch-left.png'
import branchRight from './../../../img/branch-right.png'

const branchAnimBase = {
  entry: {
    opacity: 1,
    rotate: 0,
    transition: {
      delay: 1,
      rotate: { type: 'spring', stiffness: 200, mass: 1, dampness: 15 },
    },
  },
}

const branchAnimLeft = {
  ...branchAnimBase,
  initial: {
    opacity: 0,
    rotate: -10,
  },
}

const branchAnimRight = {
  ...branchAnimBase,
  initial: {
    opacity: 0,
    rotate: 10,
  },
}

export const CloudSky = () => (
  <motion.div
    animate={{ opacity: [0, 1] }}
    transition={{ delay: 1 }}
    exit={{ opacity: 0, transition: { delay: 1 } }}
  >
    <Cloud src={cloud01} anim={cloudMovementRight} top="20%" right="20%" />
    <Cloud src={cloud02} anim={cloudMovementLeft} top="30%" right="15%" />
    <Cloud src={cloud03} anim={cloudMovementLeft} top="40%" right="25%" />
    <Cloud src={cloud04} anim={cloudMovementRight} top="25%" left="15%" />
    <Cloud src={cloud05} anim={cloudMovementLeft} top="35%" left="25%" />
  </motion.div>
)

export const Branches = () => (
  <motion.div exit={{ opacity: 0, transition: { delay: 0.3 } }}>
    <BranchLeft
      src={branchLeft}
      top="40%"
      left="-7.5%"
      initial="initial"
      animate="entry"
      variants={branchAnimLeft}
    />
    <BranchRight
      src={branchRight}
      top="40%"
      right="-2%"
      initial="initial"
      animate="entry"
      variants={branchAnimRight}
    />
  </motion.div>
)

export const BackgroundElements = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;

  width: calc(100% - 50px);
  height: calc(100% - 50px);

  transform: translate(-50%, -50%);

  pointer-events: none;
  overflow: hidden;
`

const ElementBase = props => css`
  position: absolute;
  top: ${props.top};
  left: ${props.left};
  right: ${props.right};
  bottom: ${props.bottom};
  animation-name: ${props.anim};
`

const Branch = styled(motion.img)`
  display: block;
  ${ElementBase};
`

const BranchLeft = styled(Branch)`
  transform-origin: bottom left;
  width: 25vw;
  max-width: 638px;
`

const BranchRight = styled(Branch)`
  transform-origin: bottom right;
  width: 15vw;
  max-width: 288px;
`

const Cloud = styled.img`
  animation: 5s ${easings.easeInOutQuad} alternate infinite;
  ${ElementBase};
`

const cloudMovementRight = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(20%); }
`

const cloudMovementLeft = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-10%); }
`
